import { Typography } from '@mui/material';

import Grid from 'components/core/Grid';
import { listAirbnbVrboImage } from 'config/imageUrls';

import { ContentSection } from './styles';

export const WorksOtherHosting = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h2">Works With Other Hosting Websites</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <img src={listAirbnbVrboImage} width="100%" className="add-image-shadow" />
          </Grid>
          <Grid item xs={12} sm={10}>
            <Typography pb={1}>
              alluraDirect works seamlessly with other vacation rental listing websites including airBNB, VRBO,
              HomeAway, Booking.com, TripAdvisor and more. Calendar availability will sync between platforms to ensure
              there are no double bookings.
            </Typography>
            <Typography pb={1}>
              Increase and diversify your rental revenue by including alluraDirect as one of your booking channels with
              no-risk.
            </Typography>
            <Typography>
              If you are using a property management system (PMS) or a listing channel manager for your vacation rental
              property, please contact our sales team for integration options and setup support.
            </Typography>
          </Grid>
        </Grid>
      </ContentSection>
    </>
  );
};
